import { alpha } from '@mui/material/styles'
import { UI_COLOR_ACCENT_ORANGE, UI_COLOR_PRIMARY } from './uiColors'

export const loadingSpinnerRootSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1.5,
  whiteSpace: 'nowrap',
  lineHeight: 1
}

export function getLoadingSpinnerIndicatorSx(size, color) {
  return {
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    flexShrink: 0,
    borderRadius: '50%',
    border: `3px solid ${alpha(UI_COLOR_PRIMARY, 0.16)}`,
    borderTopColor: color,
    borderRightColor: alpha(UI_COLOR_ACCENT_ORANGE, 0.88),
    animation: 'loading-spinner-rotate 0.72s cubic-bezier(0.4, 0, 0.2, 1) infinite',
    verticalAlign: 'middle',
    boxShadow: `0 0 0 5px ${alpha(UI_COLOR_PRIMARY, 0.05)}`,
    '@keyframes loading-spinner-rotate': {
      from: {
        transform: 'rotate(0deg)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    }
  }
}

export function getLoadingSpinnerTextSx(color) {
  return {
    m: 0,
    color,
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1.25,
    verticalAlign: 'middle'
  }
}
